import { withStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import { fetchAllUsers } from '@tuqqi/common';
import moment from "moment";
import React from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { compose } from 'recompose';
import { showConfirm, showSnackbar } from '../../../../actions/appActions';
import { globalDataLoad } from '../../../../actions/globalDataAction.js';
import parseImagUrl from "../../../../ui/components/Common/parseImagUrl";
import { SERVER_API } from '../../../../utils/serverAPI.js';
import PhoneInput from '../../../components/Common/Text/PhoneInput.js';
import UserAvatar from '../../../components/Common/UserAvatar';
import { ORG_ADMIN, ORG_CONTRIBUTOR, ORG_VIEWER } from '../../../components/Common/Utils/userPermissionsUtils';
import AutosuggestChip from '../../../components/Header/SubheaderToolbar/Filters/AutosuggestChip.js';
import DatePicker from '../../../components/Header/SubheaderToolbar/Filters/DatePicker.js';
import AdminEditContainer from '../AdminEditContainer.js';
import SelectSuperior from './SelectSuperior.js';


const styles = theme => ({
    item: {
        padding: 16,
    },

    progress: {
        margin: `0 ${theme.spacing.unit * 2}px`,
        textAlign: 'center',
        align: 'center'
    },
    spinner: {
        textAlign: 'center',
        paddingTop: 16
    },
    datePicker: {
        margin: 0,
        width: '100%'
    },
    autosuggestChip: {
        margin: 0
    }
})

const fixImage = (cloudfront, user) => {
    if (user && user.profileImageUrl) {
        user.profileImageUrl = parseImagUrl(cloudfront, user.profileImageUrl)
    }
    if (user && user.org && user.org.logo && !user.org.logo.includes('app.tuqqi.com')) {
        user.org.logo = parseImagUrl(cloudfront, user.org.logo, 145)
    }
}

export class UserManagement extends React.Component {

    state = {
        superiorTag: null,
        loaded: false,
        certificationsOptions: [],
        originalCertification: [],
        certifications: [],
        originUser: {}
    }

    createCertificationsOptions(certifications) {
        const option = certifications.map(o => ({
            label: o.title,
            value: o.id
        }))

        return option
    }

    componentWillMount = () => {
        const { user, adminService, users,t } = this.props

        if (!user) {
            this.props.goTo({ pathname: '/admin/users' })
        }
        else {
            adminService.getAllCertifications().then(certifications => {

                this.setState({
                    originalCertification: certifications,
                    certificationsOptions: this.createCertificationsOptions(certifications)
                })
            })

            adminService.getUserFullData(user.auth0_id).then(user => {
                this.setState({
                    originUser: user,
                    classification: user.classification ? user.classification : 0,
                    role: user.role ? user.role : t("Contributor"),
                    isIncludeInChallenge: user.isIncludeInChallenge,
                    auth0_id: user.auth0_id,
                    firstname: user.firstname,
                    lastname: user.lastname,
                    suggestedNews: user.suggestedNews || '',
                    tag: user.tag,
                    email: user.email,
                    title: user.title,
                    profileImageUrl: user.profileImageUrl,
                    lang: user.lang,
                    bio: user.bio,
                    birthday: user.birthday,
                    phone: user.phone,
                    homeAddress: user.homeAddress,
                    officeAddress: user.officeAddress,
                    startWorkingDate: user.startWorkingDate,
                    endWorkingDate: user.endWorkingDate,
                    subscribedChannels: user.subscribedTagsDtos.length ? user.subscribedTagsDtos.map(t => `#${t.tag}`).join(', ') : '',
                    organizationName: this.props.userData.profileData.org.title,
                    certifications: user.certificationDtos.map(c => c.id),
                    employeeId: user.employeeId,
                    lastModification: user.lastModification,
                    superiorId: user.superiorId,
                    nickname: user.nickname,
                    tag: user.tag,
                    loaded: true,
                    userId: user.id
                })
            })
        }
    }

    getSuperiorTag() {
        const { users,t } = this.props;
        const { superiorId } = this.state;

        let tag = t('Unassigned')
        if (superiorId != null) {
            const superior = users.find(u => u.id == superiorId)
            if (superior) {
                tag = `@${superior.tag}`
            }
        }

        return tag
    }

    initNotifications = () => {
        const { user, userSettingsService } = this.props;
        userSettingsService.initUserDefaulNotificationSettings(user.tag)
    }

    save = () => {
        const { dispatch, userSettingsService, user, goTo,t } = this.props;

        user.classification = this.state.classification;
        user.role = this.state.role ? this.state.role : t("Contributor");
        user.isIncludeInChallenge = this.state.isIncludeInChallenge;

        const { classification, role, isIncludeInChallenge, firstname, lastname, suggestedNews, title, bio, birthday, phone, homeAddress, officeAddress,
            startWorkingDate, endWorkingDate, employeeId, certifications, superiorId, nickname, tag } = this.state

        const editedUser = {
            // ...this.state.originUser,
            classification: classification || 0,
            role,
            isIncludeInChallenge,
            firstname,
            lastname,
            suggestedNews,
            title,
            tag,
            bio,
            birthday,
            phone,
            homeAddress,
            officeAddress,
            startWorkingDate,
            endWorkingDate,
            employeeId,
            certificationDtos: this.state.originalCertification.filter(originalCertification => this.state.certifications.includes(originalCertification.id)),
            superiorId,
            nickname,
            auth0_id: user.auth0_id
        }
        this.props.dispatch(showSnackbar('Saving...'));

        userSettingsService.editAdminUserSetting(editedUser).then((res) => {
            // If status code between 200 to 300
            if (res.status.toString().startsWith('2')) {
                userSettingsService.getUsers().then(users => {
                    const activeUsers = users.filter(x => x.status === 0);
                    users.forEach(_userDetails => fixImage(this.props.cloudfront, _userDetails))
                    activeUsers.forEach(_userDetails => fixImage(this.props.cloudfront, _userDetails))

                    this.props.dispatch(globalDataLoad({users, activeUsers}));
                    this.props.dispatch(fetchAllUsers(SERVER_API));
                    this.props.dispatch(showSnackbar('Saved!'));
                });
            } else {
                this.props.dispatch(showSnackbar('Saving failed: ' + res.statusText));

            }
            goTo({ pathname: '/admin/users' });
        });
    }

    onChange = (name, newValue) => {
        this.setState({ [name]: newValue });
    }

    handleChangeAutoSuggest = (newValue) => {
        const data = (newValue || []).map(val => val.value)
        this.setState({ certifications: data })
    }

    toggleSuperior = () => {
        this.setState({ openSuperior: !this.state.openSuperior })
    }

    selectUser = (superiorId) => {
        const superior = this.props.users.find(u => u.id === superiorId)
        const superiorTag = superior ? '@' + superior.tag : null
        this.setState({ superiorId, superiorTag })
    }
    fixInvalidUserName = (userName) => {
        return (userName || '').replace(/\t|\s|\n/gm, '').toLowerCase()
    }

    removeInvalidName = (name) => {
        return name.replace(/^[^a-z]+[^a-z0-9]*/gi, "")
    }

    onDeleteUser = () => {

        const { dispatch, userSettingsService, user, goTo } = this.props
        const action = () => {
            userSettingsService.deleteUser(user.id).then(x => {
                userSettingsService.getUsers().then(users => {
                    dispatch(globalDataLoad({ users: users }))
                    goTo({ pathname: '/admin/users' });
                })
            })
        }

        dispatch(showConfirm(("Are you sure you want to delete this user? This action can't be undone"), action))

    }

    handleTextFieldChange = (field) => (event) => {
        this.setState({ [field]: event.target.value });
    }

    handleTagChange = (event)=>{

        let removeAt = event.target.value.replace('@','');
        const text = this.removeInvalidName(this.fixInvalidUserName(removeAt))

        this.setState({ tag: text });
    }

    render() {
        const { classes, classifications, user, userData,t } = this.props;

        const { loaded } = this.state
        if (!user || !loaded) {
            return null
        }


        return (
            <AdminEditContainer save={this.save} title={t('Edit user')} subtitle={t('Edit role and classifications (0 is the smallest classification)')} description=''>
                <Grid container direction='column'>
                    <ListItem item container direction='row'>
                        <UserAvatar userUUID={user.auth0_id} withShadow={true} />
                        <ListItemText
                            primary={user.firstname + " " + user.lastname}
                            secondary={user.email} />
                    </ListItem>
                    <Grid item container direction='column'>
                        <Grid item className={classes.item}>
                            <TextField
                                fullWidth
                                value={this.state.classification}
                                id={user.id}
                                label={t("User classification")}
                                select
                                onChange={this.handleTextFieldChange('classification')}>
                                <MenuItem key="public" value={0}>
                                    {`${t("public")} - ${t('level')}: 0`}
                                </MenuItem>
                                {classifications.map(option => (
                                    <MenuItem key={option.uId} value={option.level}>
                                        {option.displayName + ` - ${t('level')}: ` + option.level}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item className={classes.item}>
                            <TextField
                                disabled={userData.profileData.auth0_id === user.auth0_id}
                                fullWidth
                                value={this.state.role}
                                id={user.id}
                                label={t("User role")}
                                select
                                onChange={this.handleTextFieldChange('role')}>

                                <MenuItem key="admin" value={ORG_ADMIN}>
                                    {ORG_ADMIN}
                                </MenuItem>
                                <MenuItem key="contributor" value={ORG_CONTRIBUTOR}>
                                    {ORG_CONTRIBUTOR}
                                </MenuItem>
                                <MenuItem key="viewer" value={ORG_VIEWER}>
                                    {ORG_VIEWER}
                                </MenuItem>
                            </TextField>
                        </Grid>

                        <Grid item className={classes.item}>
                            <TextField
                                disabled={userData.profileData.auth0_id === user.auth0_id}
                                fullWidth
                                value={this.state.isIncludeInChallenge}
                                label={t("User include in challenge")}
                                select
                                onChange={this.handleTextFieldChange('isIncludeInChallenge')}>
                                <MenuItem value={true}>
                                    {t('Include')}
                                </MenuItem>
                                <MenuItem value={false}>
                                    {t('Exclude (is robot)')}
                                </MenuItem>
                            </TextField>
                        </Grid>



                        <Grid item className={classes.item}>
                            <TextField
                                fullWidth
                                value={this.state.firstname}
                                label={t("First Name")}
                                onChange={this.handleTextFieldChange('firstname')} />
                        </Grid>
                        <Grid item className={classes.item}>
                            <TextField
                                fullWidth
                                value={this.state.lastname}
                                label={t("Last Name")}
                                onChange={this.handleTextFieldChange('lastname')} />
                        </Grid>
                        <Grid item className={classes.item}>
                            <TextField
                                fullWidth
                                value={'@' + this.state.tag}
                                label={t("User Name")}
                                helperText={"Changing user tag will disconnect existing user tagging."}
                                // error={"Changing user tag will disconnect existing user tagging."}
                                onChange={this.handleTagChange} />
                        </Grid>

                        <Grid item className={classes.item}>
                            <TextField
                                fullWidth
                                value={this.state.title}
                                label={t("Title")}
                                onChange={this.handleTextFieldChange('title')} />
                        </Grid>

                        <Grid item className={classes.item}>
                            <TextField
                                disabled
                                fullWidth
                                value={this.state.subscribedChannels}
                                label={t("Subscribed channels")} />
                        </Grid>

                        <Grid item className={classes.item}>
                            <TextField
                                disabled
                                fullWidth
                                value={this.state.email}
                                label={t("Email")} />
                        </Grid>
                        <Grid item className={classes.item}>
                            <TextField
                                disabled
                                fullWidth
                                value={this.state.lang}
                                label={t("Language")} />
                        </Grid>
                        <Grid item className={classes.item}>
                            <TextField
                                disabled
                                fullWidth
                                value={this.state.organizationName}
                                label={t("Organization Name")} />
                        </Grid>
                        <Grid item className={classes.item}>
                            <TextField
                                fullWidth
                                value={this.state.suggestedNews}
                                label={t("Suggested News")}
                                onChange={this.handleTextFieldChange('suggestedNews')} />
                        </Grid>


                        <Grid item className={classes.item}>
                            <TextField
                                multiline
                                fullWidth
                                value={this.state.bio}
                                label={t("Bio")}
                                onChange={this.handleTextFieldChange('bio')} />
                        </Grid>
                        <Grid item className={classes.item}>
                            <DatePicker
                                classes={{ datePicker: classes.datePicker }}
                                selectedDate={this.state.birthday}
                                onChange={(date) => this.onChange("birthday", date)}
                                label={t('Birthday')} />
                        </Grid>

                        <Grid item className={classes.item}>
                            <PhoneInput label={t("Phone Number")} value={this.state.phone} onChange={this.handleTextFieldChange('phone')} />
                        </Grid>

                        <Grid item className={classes.item}>
                            <TextField
                                fullWidth
                                value={this.state.homeAddress}
                                label={t("Home address")}
                                onChange={this.handleTextFieldChange('homeAddress')} />
                        </Grid>



                        <Grid item className={classes.item}>
                            <TextField
                                fullWidth
                                value={this.state.officeAddress}
                                label={t("Office address")}
                                onChange={this.handleTextFieldChange('officeAddress')} />
                        </Grid>

                        <Grid item className={classes.item}>
                            <DatePicker
                                classes={{ datePicker: classes.datePicker }}
                                selectedDate={this.state.startWorkingDate}
                                onChange={(date) => this.onChange("startWorkingDate", date)}
                                label={t('Start Working Date')} />
                        </Grid>
                        <Grid item className={classes.item}>
                            <DatePicker
                                classes={{ datePicker: classes.datePicker }}
                                selectedDate={this.state.endWorkingDate}
                                onChange={(date) => this.onChange("endWorkingDate", date)}
                                label={t('End Working Date')} />
                        </Grid>

                        <Grid item className={classes.item}>
                            <AutosuggestChip classes={{ root: classes.autosuggestChip }} placeholder={t('Select multiple Certifications')} handleChange={this.handleChangeAutoSuggest} suggestions={this.state.certificationsOptions} label={t('Certifications')} selected={this.state.certifications} />
                        </Grid>

                        <Grid item className={classes.item}>
                            <TextField
                                fullWidth
                                value={this.state.employeeId}
                                label={t("Employee Id")}
                                onChange={this.handleTextFieldChange('employeeId')} />
                        </Grid>
                        <Grid item className={classes.item}>
                            <TextField
                                disabled
                                fullWidth
                                value={moment(this.state.lastModification).format('MMMM Do YYYY, H:mm')}
                                label={t("Last update")} />
                        </Grid>

                        <Grid item className={classes.item}>
                            <TextField
                                fullWidth
                                value={this.state.nickname}
                                label={t("Nickname")}
                                onChange={this.handleTextFieldChange('nickname')} />
                        </Grid>



                        <Grid onClick={this.toggleSuperior} item className={classes.item}>
                            <TextField
                                fullWidth
                                value={this.getSuperiorTag()}
                                label={t("Superior")} />
                        </Grid>

                    </Grid>

                    <ListItem item>

                        <Button
                            variant="raised"
                            onClick={this.initNotifications}
                            className={classes.buttonIc}>
                            {t('Init Notifications')}
                        </Button>
                    </ListItem>
                    <ListItem item>

                        <Button
                            variant="raised"
                            onClick={this.onDeleteUser}
                            className={classes.buttonIc}>
                            {t('Delete user')}
                        </Button>
                    </ListItem>

                </Grid>
                <SelectSuperior userId={this.state.userId} open={this.state.openSuperior} handleClose={this.toggleSuperior} selectUser={this.selectUser} superiorId={this.state.superiorId} />
            </AdminEditContainer>)

    }

}

const mapStateToProps = (state) => ({
    ...state.services,
    globalData: state.globalData,
    users: state.globalData.users,
    userData: state.userData,
    classifications: state.globalData.classifications,
    user: state.customMappings.currentUser,
    cloudfront: state.globalData.cloudfront,
})

const mapDispatchToProps = dispatch => {
    return {
        goTo: path => { dispatch(push(path)) },
        dispatch: dispatch
    }
}

export default compose(withStyles(styles),
withTranslation('admin'),
connect(
        mapStateToProps,
        mapDispatchToProps
    ))(UserManagement);